import createPage from '../create-page'
import Home from './home'

const autoNavigate = false
const immediateTransition = true

export default createPage(Home, 'HOME', autoNavigate, immediateTransition)



// WEBPACK FOOTER //
// ./src/components/home-page/index.js